(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4136],{

/***/ 21703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ RegisterPage; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_signup_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30488);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99109);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1283);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57626);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79709);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var __N_SSP = true;
function RegisterPage(props) {
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("title-pages");
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var user = (0,custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(function (state) {
    return state.Auth.user;
  });

  function onSignUpSuccess() {
    router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_6__/* .CPagesPath.es.home */ .K.es.home);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (user) router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_6__/* .CPagesPath.es.profile */ .K.es.profile);
  }, [user, router]);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    showFooter: true
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("title", null, titleT("signup")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(props.url)),
    key: "canonical"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Center, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Content, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_signup_form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    onSignUpSuccess: onSignUpSuccess,
    isPage: true
  }))));
}

var Center = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e9t8i8z1"
} : 0)( true ? {
  name: "1jp9ql7",
  styles: "display:grid;place-content:center;padding:20px;@media (min-height: 1100px){height:var(--main-height);}"
} : 0);

var Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e9t8i8z0"
} : 0)( true ? {
  name: "7bmwec",
  styles: "background-color:white;max-width:600px;padding:70px 20px 20px;border-radius:40px;box-shadow:0px 4px 12px rgba(0, 0, 0, 0.13);margin:100px 0"
} : 0);

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ }),

/***/ 93064:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrate",
      function () {
        return __webpack_require__(21703);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,2708,1629,8407,2615,6877,4022,70,3843,1664,7918,9043,8543,2960,7956,4864,841,2834,311,9343,4816,5675,207,6064,3282,2210,9709,2888,179], function() { return __webpack_exec__(93064); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);